import { useEffect, useState, useContext } from "react";
import axios from "axios";
import MyContext from "../../../../MyContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Customization = ({ userID }) => {
  const { baseUrl, config } = useContext(MyContext);

  const [customizations, setCustomizations] = useState([]);
  const [newCustomization, setNewCustomization] = useState("");
  const [customizationType, setCustomizationType] = useState("");
  const [loading, setLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);

  // ✅ Fetch all existing customizations
  const getCustomizations = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getPosOrderCustomizations`,
        { userid: userID },
        config
      );
      if (response.data.responseCode === "00") {
        setCustomizations(response.data.response || []);
      } else {
        toast.error("Failed to fetch customizations");
      }
    } catch (error) {
      console.error("Failed to fetch customizations", error);
      toast.error("Error fetching customizations");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Add a new customization
  const addCustomization = async () => {
    if (!newCustomization.trim() || !customizationType) {
      toast.warning("Please enter both customization and type");
      return;
    }
    setAddLoading(true);
    try {
      const payload = {
        userid: userID,
        customization: newCustomization.trim(),
        customizationType: customizationType,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/Pos/addCustomization`,
        payload,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success("Customization added successfully");
        setNewCustomization("");
        setCustomizationType("");
        getCustomizations();
      } else {
        toast.error(response.data.responseMessage || "Failed to add customization");
      }
    } catch (error) {
      console.error("Failed to add customization", error);
      toast.error("Error adding customization");
    } finally {
      setAddLoading(false);
    }
  };

  // ✅ Delete a customization
  const deleteCustomization = async (id) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/Pos/deleteCustomization`,
        {
          userid: userID,
          customizationId: id,
        },
        config
      );

      if (response.data.responseCode === "00") {
        toast.success("Customization deleted successfully");
        getCustomizations();
      } else {
        toast.error("Failed to delete customization");
      }
    } catch (error) {
      console.error("Failed to delete customization", error);
      toast.error("Error deleting customization");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCustomizations();
  }, []);

  return (
    <div className="row">
      <ToastContainer />
      <div className="col-12">
          {/* Add new customization */}
        <div className="p-4 bg-light border-0 mb-4 rounded-4">
          <h5 className="fw-semibold text-success mb-4">
            Add Customization
          </h5>
          <div className="row g-4 align-items-end">
            <div className="col-md-6">
              <label className="form-label">Customization</label>
              <input
                type="text"
                className="form-control"
                placeholder="e.g., Extra Spicy, No Garlic"
                value={newCustomization}
                onChange={(e) => setNewCustomization(e.target.value)}
                disabled={addLoading}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Customization Type</label>
              <select
                className="form-control"
                value={customizationType}
                onChange={(e) => setCustomizationType(e.target.value)}
                disabled={addLoading}
              >
                <option value="">Select Type</option>
                <option value="customize">Customize</option>
                <option value="add-ons">Add-ons</option>
              </select>
            </div>

            <div className="col-md-3">
              <button
                className="btn btn-success"
                onClick={addCustomization}
                disabled={addLoading}
              >
                {addLoading ? "Adding..." : "Add"}
              </button>
            </div>
          </div>
        </div>
        {/* Existing customizations */}
        {customizations.length > 0 &&
          customizations.map((item, index) => (
            <div key={index} className="col">
              <div className="p-4 bg-white w-100 border rounded-4 mb-3">
                <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                  <h5 className="fw-semibold text-success">
                     {item.customization} <small>({item.customization_type})</small> 
                  </h5>
                  <div>
                    <button
                      className="btn btn-danger"
                      onClick={() => deleteCustomization(item.id)}
                      disabled={loading}
                    >
                      Remove
                    </button>
                  </div>
                </div>
                <div className="d-flex flex-column gap-2">
                  <div className="d-flex justify-content-between">
                    <span className="text-muted">Customization:</span>
                    <span className="fw-medium text-dark">
                      {item.customization}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span className="text-muted">Type:</span>
                    <span className="fw-medium text-dark">
                      {item.customization_type}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}

      
      </div>
    </div>
  );
};

export default Customization;
